/**
 * 애플리케이션 라우트 경로 상수
 * 화면 ID는 docs/README.md §3 화면 목록을 따른다.
 *
 * admin은 enum이지만 여기서는 `as const` 객체로 둔다.
 * enum 멤버 타입은 TanStack Router가 라우트 경로 리터럴로 좁히지 못해
 * validateSearch가 있는 라우트가 하나라도 있으면 모든 Link · redirect에 search가 필수가 된다.
 */
export const ROUTE_PATHS = {
  /** M-01 로그인 */
  LOGIN: '/login',
  /** M-01 SNS 로그인 콜백 — 제공자 콘솔에 등록한 redirect URI와 같은 경로 */
  AUTH_CALLBACK: '/auth/callback/$provider',
  /** M-04 · M-05 거래처 — 웹 1차 기본 랜딩 (홈 화면 없음) */
  ACCOUNTS: '/accounts',
  ACCOUNT_DETAIL: '/accounts/$relationshipId',
  /** M-08 실적 대시보드 (연간) */
  PERFORMANCE: '/performance',
  /** M-09 · M-16 · M-17 월 실적 (yearMonth = YYYY-MM, tab으로 탭 구분) */
  PERFORMANCE_MONTH: '/performance/$yearMonth',
  /** M-10 · M-11 의약품 검색 (q가 있으면 결과 화면) */
  DRUGS: '/drugs',
  /** M-13 A3 앱 전용 기능 전면 안내 */
  APP_ONLY: '/app-only/$feature',
} as const;

/** GNB 메뉴 — 맥스매치는 웹 미제공(A1 팝오버) */
export const GNB_MENUS = [
  { label: '거래처', to: ROUTE_PATHS.ACCOUNTS },
  { label: '실적', to: ROUTE_PATHS.PERFORMANCE },
  { label: '의약품 검색', to: ROUTE_PATHS.DRUGS },
] as const;
